import { createSelector } from '@reduxjs/toolkit';
import { filter, indexOf } from 'lodash';
import { RootState } from 'src/root/store';

import { RelationshipType } from '@appTypes/esb';
import { supportedYouthRelationshipTypes } from '@modules/youthProfile/constants';
import { awardsSel, dictionarySel, emptyArr } from '@shared';

import { dictionaryIds } from '../constants';

export {
  allAwardsSel,
  ranksSel,
  ssElectivesSel,
  adventuresSel,
  meritBadgesSel,
} from '@shared';
export { awardsSel, dictionarySel };

export const relationshipTypesSel = (state: RootState) =>
  (dictionarySel(
    state,
    dictionaryIds.RELATIONSHIP_TYPES,
  ) as RelationshipType[]) || (emptyArr as unknown as RelationshipType[]);

const filterRelationshipTypes = (relationshipTypes: RelationshipType[]) =>
  filter(
    relationshipTypes,
    type => indexOf(supportedYouthRelationshipTypes, type.name) !== -1,
  );

export const relationshipTypesFilteredSel = createSelector(
  relationshipTypesSel,
  unfilteredRel => filterRelationshipTypes(unfilteredRel),
);
